// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3471":"20a8018bc09347ed74ce","7468":"73edb1a3e40e6fad0c13"}[chunkId] + ".css";
};